function shipmentsSingleBookingRequestsController() {
  const vm = this;

  /** Initial values for the controller */
  vm.orderByField = "RequestID";
}

export default shipmentsSingleBookingRequestsController;
